import { defineComponent as _defineComponent } from 'vue'
import { ref,computed, watch } from 'vue'
  import { AloDbCoverageIteration } from '@/models/alodb/AloDbCoverageIteration'  
  import store from '@/store'    
  import { buildCoverageIterationMissionUiStateId } from '@/models/ui/CoverageIterationMissionUiState'  
  import { AloDbFleet } from '@/models/alodb/AloDbFleet'
  import { AloMission } from '@/models/alo/AloMission'
  import { buildMissionUIStateId } from '@/models/ui/MissionUiState'
import mission from '@/api/mission'

  
export default /*#__PURE__*/_defineComponent({
  __name: 'FleetTimeLine',
  props: {
    fleet: null,
    uiid: null
  },
  setup(__props: any) {

const props = __props as {    
    fleet:AloDbFleet,
    uiid:string};

  
  const isPlaying = ref(false)

  const _currentValue = ref(-1)
  
  const currentValue = computed({
    get: () => _currentValue.value == -1?(allYos.value.length > 0?allYos.value.length-1:0): _currentValue.value,
    set: (val) => {
      _currentValue.value = val
    }
  })  
  
  
    
  const fleetState = computed(()=> store.myGetters.fleetUiStateByUiid(props.uiid))
  
  const  missions = computed(()=> props.fleet.param?.missionIds?.map(id => store.myGetters?.missionsById[id])?.filter(m => !!m) ?? [])
  

  const timelineIndex = computed(()=> fleetState.value.timelineIndex)

  const missionTimelineIndex = computed(()=> missions.value.map(mission => store.myGetters.missionUiStateByUiid(buildMissionUIStateId(mission.misId!,'fleet')).timelineIndex))

  const currentDate = computed(()=> allYos.value?.[currentValue.value]?.date)

  const canUpdateYoIndex = ref(true)

  function changeValue(newValue:number){
    fleetState.value.timelineIndex = newValue
  }
  

  const allYos = computed(()=> 
    missions.value.reduce((acc, mission, misIdx) => {
      const yos = mission.yoArray?.map((y,idx) => ({misId:mission.misId!,gliderNum:misIdx+1,idx,date:y?.yoGpsDatTime,isUnderWater:y?.isUnderWater,cycle:y?.yosCycle})) ?? [] 
      let lastDate = yos?.at(0)?.date!
      yos?.forEach(y => {        
        if(y.date.toString() =='Invalid Date') {           
          y.date = new Date(lastDate.getTime() + 1)
          lastDate = y.date
        }
        else lastDate = y.date
      })
      //@ts-ignore
      return acc.concat(yos)
    },[] as Array<{misId:number,gliderNum:number,idx:number,date:Date,isUnderWater:boolean,cycle:number}>).sort((a,b) => a.date.getTime() - b.date.getTime())
  )  
  

  function goPrevYo(val:number){
      let yo = null                
      let offset = 1
      while(val-offset >= 0 && (yo = allYos.value[val-offset]).isUnderWater){
        offset++;
      }        
      if(yo && !yo.isUnderWater)  changeValue(val - offset)
  }

  function goNextYo(val:number){
      let yo = null              
      let offset = 1
      while(allYos.value.length > (val+offset) &&  (yo = allYos.value[val+offset]).isUnderWater){
        offset++;
      }        
      if(yo && !yo.isUnderWater) changeValue(val + offset)
  }

  

  watch(timelineIndex, (newIndex:number) => {
    checkIndex(newIndex)
  })

  watch(missionTimelineIndex, (newIndexes:Array<number>,oldIndexes:Array<number>) => {
    if(canUpdateYoIndex.value){      
      //recherche le premier index qui a changé
      let newIndex = newIndexes.findIndex((newIndex,idx) => newIndex != oldIndexes[idx])
      const missionToFind = missions.value[newIndex]
      const indexToFind = newIndexes[newIndex]

      const newYos = allYos.value.findIndex(yo => yo?.misId == missionToFind?.misId && yo?.idx == indexToFind)
      changeValue(newYos)
    }
  })

  watch(isPlaying, (playing:boolean) => {
    if(playing) {  
      //si on reviens au debut on attend que l'animation du curseur de la time line soit fini avant de lancer le play                      
      if(currentValue.value == allYos.value.length - 1) {
        changeValue(0)
        setTimeout(() => play(),350)          
      } 
      else  {                     
        play()
      }
    }      
  })

  function play() {
      if(isPlaying.value) {
        if(currentValue.value == allYos.value.length - 1) {
          isPlaying.value = false
        }
        else{
          changeValue(currentValue.value+1)            
          setTimeout(() => play(),350)
        }     
      }
  }


  
  function checkIndex(newIndex:number) {    
    canUpdateYoIndex.value = false
    currentValue.value = newIndex != -1? newIndex : allYos.value.length-1
    //Met à jour la position de chaque glider de la simulation à l'index le plus proche
    missions.value.forEach(mission => {
      //recherche de l'index le plus proche pour chaque glider   
      let searchIndex = currentValue.value
      let searchYo = null
      while(searchIndex >= 0 &&  (searchYo = allYos.value[searchIndex]).misId != mission.misId) {
        searchIndex--;
      }         
      const missionUiStateId = buildMissionUIStateId(mission.misId!,'fleet')      
      store.myGetters.missionUiStateByUiid(missionUiStateId).timelineIndex = searchYo?.misId == mission.misId?searchYo!.idx:0
      
    })
    setTimeout(() => canUpdateYoIndex.value = true,100)
  }
  


return { __sfc: true,isPlaying, _currentValue, currentValue, props, fleetState, missions, timelineIndex, missionTimelineIndex, currentDate, canUpdateYoIndex, changeValue, allYos, goPrevYo, goNextYo, play, checkIndex }
}

})